const login = {
  title: "Sign In",
  emailLabel: "Email",
  passwordLabel: "Password",
  forgotPassword: "Forgot password?",
  twoFactorLabel: "Two-Factor Code",
  twoFactorPlaceholder: "000000",
  twoFactorHint: "Enter the 6-digit code from your authenticator app",
  twoFactorLockoutHint:
    "Lost access to your authenticator device? Contact your admin or supervisor directly to reset your 2FA.",
  signingIn: "Signing in...",
  signIn: "Sign In",
  back: "Back",
  loginFailed: "Login failed",
  footer: {
    newHere: "New here?",
    readAbout: "Read about the system",
    invitationNotice: "— accounts are issued by invitation.",
  },
};

export default login;
